export const PRIMARY_NAVIGATION_WIDTH = 220;
export const SESSION_NAVIGATION_WIDTH = 60;
